/* eslint-disable prettier/prettier */

import { CompanyPayment } from 'models/company';
import { Response } from 'models/response';

import { axiosConfig, profile } from '../api';

export const updateCompanyPayment = async (
  companyPayment: CompanyPayment, companyId: string
): Promise<Response<boolean>> => 
  
  profile
    .put<Response<boolean>>('company/UpdatePaymentMethod/' + companyId, companyPayment, axiosConfig)
    .then((response) => response.data) 
    .catch((error) => {
      throw error.response?.data || error;
    });
